import {
  faLongArrowAltDown,
  faLongArrowAltUp,
} from "../../../assets/consts/faCharCodes";

export function getIconPicture(group, key) {
  if (group == "facilityIcons") {
    switch (key) {
      case 10: // نظافت
        return "\uf51a";

      case 11: // باغبانی
        return "\uf800";

      case 12: // پیک
        return "\uf21c";

      case 13: // اتاق جلسه
        return "\uf8d6";

      case 14: // برگزاری ایونت
        return "\uf1fd";

      case 15: // خشکشویی
        return "\uf862";

      case 16: // پرداخت شارژ
        return "\uf571";
      case 17: //قبض آب
        return "\uf570";
      case 18: //قبض برق
        return "\uf570";
      case 60: //پارکینگ
        return "\uf615";
      case 1001: //شارژ کیف پول
        return "\uf53d";
      case 30: //رستوران
        return "\uf2e6";
      case 50:
        return "\uf5e6";
      case 40:
        return "\uf7b6";

      case "Restaurant": //رستوران
        return "\uf2e6";

      case "CoffeeShop": //کافی شاپ
        return "\uf7b6";

      case "CarWash": //کارواش
        return "\uf5e6";
      case "Parking":
        return "\uf615";
      case null:
        return "\uf562";
        default : 
        return "\uf562";
    }
  } else if (group == "statusOrder") {
    switch (key) {
      case 1: //ثبت شده
        return "\uf872";
      case 2: //در دست بررسی
        return "\uf28b";
      case 3: //در دست اقدام
        return "\uf252";
      case 4: //انجام شده
        return "\uf058";
      case 5: //لغو
        return "\uf057";
      case 6: //	انصراف درخواست کننده
        return "\uf4fa";
      // return "\ue060";
      case 7: //کمبود منابع
        return "\uf28b";
      case "withdraw": //برگشت مبلغ
        return faLongArrowAltUp;
      case "deposit": // پرداخت شده
        return faLongArrowAltDown;
      case null:
        return "\uf562";
    }
  }
}
